import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import {
  fetchOutgoingOrdersByDate,
  fetchSalesOrders,
} from '../../actions/sales_actions';
import { fetchDashboardMessages, postDashboardMessage, setField } from '../../actions/dashboard_actions';
import {
  fetchIncomingOrdersByDate,
  fetchPurchaseOrders,
  fetchPurchaseOrdersNotReceived,
  fetchTotalPurchases,
  resetCurrentPurchaseOrder,
  selectPurchaseOrder,
} from '../../actions/purchaseOrders_actions';


import GeneralDashboard from '../../components/General/generalDashboardRevision';

const generalDashboard = reduxForm({
  form: 'generalDashboard',
})(GeneralDashboard);

const selector = formValueSelector('generalDashboard');

function mapStateToProps(state) {
  const poDateChosen = selector(state, 'selectedPODate');
  const soDateChosen = selector(state, 'selectedSODate');
  const Message = selector(state, 'MessageField');

  return {
    poDateChosen,
    soDateChosen,
    Message,

    todaysIncomingOrders: state.purchaseOrders.todaysIncomingOrders,
    todaysIncomingOrdersIsLoading: state.purchaseOrders.todaysIncomingOrdersIsLoading,
    todaysIncomingOrdersError: state.purchaseOrders.todaysIncomingOrdersError,

    todaysOutgoingOrders: state.salesOrders.todaysOutgoingOrders,
    todaysOutgoingOrdersIsLoading: state.salesOrders.todaysOutgoingOrdersIsLoading,
    todaysOutgoingOrdersError: state.salesOrders.todaysOutgoingOrdersError,

    salesOrders: state.salesOrders.all,
    SOIsLoading: state.salesOrders.isLoading,
    SOError: state.salesOrders.error,

    messages: state.dashboard.messages,
    messagesIsLoading: state.dashboard.messagesIsLoading,
    messagesError: state.dashboard.messagesError,
  };
}

export default connect(mapStateToProps, {
  fetchDashboardMessages,
  fetchIncomingOrdersByDate,
  fetchOutgoingOrdersByDate,
  fetchPurchaseOrders,
  fetchPurchaseOrdersNotReceived,
  fetchSalesOrders,
  fetchTotalPurchases,
  postDashboardMessage,
  resetCurrentPurchaseOrder,
  selectPurchaseOrder,
  setField,
})(generalDashboard);



// WEBPACK FOOTER //
// ./master/jsx/containers/General/generalDashboardRevision.jsx